/**
 * TapPay 當頁刷卡欄位的 DOM 掛載與取 prime，抽獎與出貨共用同一份 markup
 * （`templates/partials/draw-pay-card-fields.php`，出貨側原樣 include）。
 * 含 DOM，不納入 `node --test`（同 draw-pay-popup.js 的決議 18）。
 */

/**
 * @param {object} deps
 * @param {(update: {status?: object, canGetPrime?: boolean, hasError?: boolean}) => void} deps.onStatusChange
 *   TPDirect `onUpdate` 回呼原樣轉發，呼叫端自行決定要不要顯示訊息／記錄狀態。
 */
export function createTapPayCardFields(deps) {
    var onStatusChange = deps.onStatusChange;
    var setup = false;

    // TPDirect Fields 只 setup 一次（決議 18）：容器常駐 DOM，切換付款方式只切顯示，
    // 官方查無重複掛載的行為說明，防禦性地不重掛。
    function setupTapPayCardFields() {
        if (setup || typeof window.TPDirect === 'undefined' || !window.WTOY_TAPPAY_DRAW) {
            return;
        }
        var settings = window.WTOY_TAPPAY_DRAW;
        window.TPDirect.setupSDK(settings.app_id, settings.app_key, settings.server_type);
        window.TPDirect.card.setup({
            fields: {
                number: { element: '#wtoy_draw_pay_card_number', placeholder: '卡號' },
                expirationDate: { element: '#wtoy_draw_pay_card_expiry', placeholder: 'MM / YY' },
                ccv: { element: '#wtoy_draw_pay_card_ccv', placeholder: 'CCV' },
            },
        });
        window.TPDirect.card.onUpdate(function(update) {
            onStatusChange(update);
        });
        setup = true;
    }

    function getCardPrime(callback) {
        window.TPDirect.card.getPrime(callback);
    }

    return {
        setupTapPayCardFields: setupTapPayCardFields,
        getCardPrime: getCardPrime,
    };
}
